<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  props: {
    jobId: {
      type: String,
      value: "",
    },
  },
  data() {
    return {
      mname: "job",
      key: "jobId",
      url: {
        get: "/admin/monitor/job",
        add: "/admin/monitor/job",
      },
      items: [
        { label: "", desc: "是否确认执行", type: "header" },
        // {
        //   label: "责任人",
        //   name: "maintainerId",
        //   value: "",
        //   type: "select",
        //   dropList: [],
        // },
        //  {
        //   label: "巡检开始时间",
        //   name: "patrolBeginTime",
        //   value: "",
        //   type: "date",
        // },
        // { label: "巡检内容", name: "patrolContent", value: "", type: "textarea",width:"400px" },
      ],
      forms: {
        jobId: "",
      },
    };
  },
  created() {
    // let query = this.$route.query
    //     if(query.inventoryId) {
    //         this.inventoryId = query.inventoryId
    //     }
    if (this.jobId) {
      this.initData(this.jobId);
    }
  },
  methods: {
    initData() {
      // 加载详情数据
      let jobId = this.jobId;
      $utils.api.load(`/admin/monitor/job/${jobId}`, {}).then((res) => {
        if (res && res.data) {
          this.forms = res.data;
        }
      });
    },
    handleSubmit() {
      if (!this.action) {
        return true;
      }
      let q = {};
      // q.id='';
      q.jobId = this.forms.jobId;
      q.jobGroup = this.forms.jobGroup;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(`/admin/monitor/job/run`, q, "PUT")
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
              }
              this.$Modal.remove();
              setTimeout(() => {
                $utils.url.go(0);
              }, 2000);
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
              this.$Modal.remove();
              setTimeout(() => {
                $utils.url.go(0);
              }, 2000);
            });
        }
      });
    },
  },
};
</script>
